import axios from "axios";
import Vue from "vue";
import WebFontLoader from "webfontloader";
import VueMeta from "vue-meta";

import DefaultTheme from "./themes/default/DefaultTheme";
import routerDefaultTheme from "./router";
import RoundedTheme from "./themes/rounded/RoundedTheme";
import MenuNotFound from "./MenuNotFound";

import VueI18n from "vue-i18n";

import "./registerServiceWorker";
import routerRoundedTheme from "./router/rounded";
import routerMenuNotFound from "./router/menuNotFound";
import store from "./store";

import "@/assets/css/tailwind.css";

import VTooltip from "v-tooltip";

Vue.use(VTooltip);
Vue.use(VueI18n);
Vue.use(VueMeta);

const messages = {
  en: {
    menu_types: {
      breakfast: "Breakfast",
      lunch: "Lunch",
      dinner: "Dinner",
    },
    hotel: {
      timeerrorbreakfast: "Breakfast is not bookable at the moment",
      timeerrorlunch: "Lunch is not bookable at the moment",
      timeerrordinner: "Dinner is not bookable at the moment",
      alreadyexistbreakfast: "Breakfast has already been booked for your room",
      alreadyexistlunch: "Lunch has already been booked for your room",
      alreadyexistdinner: "Dinner has already been booked for your room",
    },
    modalorder: {
      attention: "Attention",
      wait_approvation: "Wait for confirmation",
      success_takeaway_delivery:
        "Thanks for ordering! You will receive a confirmation email as soon as the restaurateur accepts your order.",
      unsuccess: "Something went wrong",
      unsoccess_descr: "The order could not be sent",
      success_title: "Order sent",
      success_descr: "Thanks for your order!",
      success_hotel_descr:
        "Thanks for ordering! In case you want to change your order, ask the waiting staff.",
    },
    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
    },
    newsletter: {
      title: "Subscribe to our newsletter",
      coupon: "and get a {value}€ coupon code",
      email: "email",
      subscribe: "Subscribe",
      privacy:
        'I have read and accept the <a class="font-medium underline" href="{value}" target="_blank">Privacy policy</a>',
      thanks: "Thanks for registering",
      thanks_copuon:
        "Thanks for registering, you will receive coupon via email",
    },
    name: "Name",
    submit: "Submit",
    email: "Email",
    review: {
      review: "Review",
      description:
        "Help us improve our service. You can leave a private review",
      thanks: "Thanks for your review",
    },
    cart: {
      item_comment: "Dish comments",
      order_now: "Order now",
      total: "Total",
      order: "Order",
      note: "Order note",
      complete_order: "Complete the order",
      alert_opening_hours: "Before ordering <u> check the opening hours. </u>",
      cant_calculate_total:
        "It is not possible to determine the total because one or more dishes have variable prices based on weigh",
      delivery_day: "Delivery date",
      delivery_hours: "Hours",
      name: "Name",
      surname: "Surname",
      phone: "Phone",
      email: "Email",
      city: "City",
      zip: "Zip",
      street: "Street",
      house_number: "House number",
      delivery_note: "Delivery notes",
      order_method: "Order type",
      free_delivery: "Free delivery",
      table_name: "Table number",
      umbrella_name: "Umbrella number",
      password: "Password",
      room_number: "Room number",
      alert_price_variable: "Attention the price is in ",
      attention: "Attention",
      attention_1: "you will not be able to change the order after sending",
      attention_2:
        "you will have to place a single order containing the choices of all the components of the room",
    },
    phone: "Phone",
    website: "Website",
    ctareview: "La tua opinione conta!",
    back: "Back",
    fix_validation_errors: "Please correct the errors",
    closed: "Closed",
  },
  it: {
    menu_types: {
      breakfast: "Colazione",
      lunch: "Pranzo",
      dinner: "Cena",
    },
    hotel: {
      timeerrorbreakfast: "La colazione non è prenotabile in questo momento",
      timeerrorlunch: "Il pranzo non è prenotabile in questo momento",
      timeerrordinner: "La cena non è prenotabile in questo momento",

      alreadyexistbreakfast:
        "La colazione è già stata prenotata per la tua camera",
      alreadyexistlunch: "Il pranzo è già stato prenotata per la tua camera",
      alreadyexistdinner: "La cena è già stata prenotata per la tua camera",
    },
    modalorder: {
      attention: "Attenzione",
      wait_approvation: "Attendere la conferma",
      success_takeaway_delivery:
        "Grazie per aver ordinato! Riceverai una email di conferma non appena il ristoratore accetterà il tuo ordine.",
      unsuccess: "Qualcosa è andato storto",
      unsoccess_descr: "Non è stato possibile inviare l'ordine",
      success_title: "Ordine inviato",
      success_descr: "Grazie per aver ordinato!",
      success_hotel_descr:
        "Grazie per aver ordinato! Nel caso volessi modificare il tuo ordine, chiedi al personale di sala.",
    },
    days: {
      monday: "Lunedì",
      tuesday: "Martedì",
      wednesday: "Mercoledì",
      thursday: "Giovedì",
      friday: "Venerdì",
      saturday: "Sabato",
      sunday: "Domenica",
    },
    newsletter: {
      title: "Iscriviti alla newsletter",
      coupon: "Riceverai subito un buono da {value}€",
      email: "email",
      subscribe: "Iscriviti",
      privacy:
        'Ho letto ed accettato la <a class="font-medium underline" href="{value}" target="_blank">Privacy policy</a>',
      thanks: "Grazie per esserti registrato",
      thanks_copuon:
        "Grazie per esserti registrato, a breve riceverai via email il coupon",
    },
    name: "Nome",
    submit: "Invia",
    email: "Email",
    review: {
      review: "Recensione",
      description:
        "Aiutaci a migliorare il nostro servizio scrivendo una recensione privata",
      thanks: "Grazie per la tua recensione",
    },
    cart: {
      item_comment: "Eventuali richieste relative al piatto",
      order_now: "Ordina",
      total: "Totale",
      order: "Comanda",
      note: "Note / Richieste",
      complete_order: "Completa l'ordine",
      alert_opening_hours:
        "Prima di ordinare <u>verifica gli orari di apertura.</u>",
      cant_calculate_total:
        "Non è possibile determinare il totale perché uno o più piatti hanno prezzi variabili in base al peso",
      delivery_day: "Data di consegna",
      delivery_hours: "Orario indicativo",
      name: "Nome",
      surname: "Cognome",
      phone: "Telefono",
      email: "Email",
      city: "Comune",
      zip: "Cap",
      street: "Via",
      house_number: "Numero civico",
      delivery_note: "Note consegna",
      order_method: "Modalità di ordinazione",
      free_delivery: "Consegna gratuita",
      table_name: "Numero tavolo",
      umbrella_name: "Numero ombrellone",
      password: "Password",
      room_number: "Numero camera",
      alert_price_variable: "Attenzione il prezzo è in ",
      attention: "Attenzione",
      attention_1: "non potrai modificare l'ordine dopo l'invio",
      attention_2:
        "dovrai effettuare un solo ordine contenente le scelte di tutti i componenti della camera",
    },
    phone: "Telefono",
    website: "Sito Web",
    ctareview: "La tua opinione conta!",
    back: "Indietro",
    fix_validation_errors: "Correggere gli errori",
    closed: "Chiuso",
  },
};

const i18n = new VueI18n({
  locale: "it",
  fallbackLocale: "en",
  messages,
});

VTooltip.options.defaultDelay = {
  show: 300,
  hide: 0,
};

async function load(uuid) {
  let location;
  try {
    const response = await axios.get(
      "https://static.menubyte.it/" + uuid + "/menu.json"
    );
    location = response.data.data;
  } catch (error) {
    console.error(error);
    notFound();
    return;
  }

  Vue.config.productionTip = false;

  //store.dispatch("setLocation", location);

  var style = document.createElement("style");
  style.type = "text/css";
  style.innerHTML =
    "body{" +
    location.font2.font_family +
    " } h1,h2,h3,h4,h5 { " +
    location.font1.font_family +
    " }";
  document.getElementsByTagName("head")[0].appendChild(style);

  var manifest = document.createElement("link");
  manifest.href = "https://static.menubyte.it/" + uuid + "/manifest.json";
  manifest.rel = "manifest";
  document.getElementsByTagName("head")[0].appendChild(manifest);

  var themeColor = document.createElement("meta");
  themeColor.name = "theme-color";
  themeColor.content = location.color.primary_hex;
  document.getElementsByTagName("head")[0].appendChild(themeColor);

  var themeColorMs = document.createElement("meta");
  themeColorMs.name = "msapplication-TileColor";
  themeColorMs.content = location.color.primary_hex;
  document.getElementsByTagName("head")[0].appendChild(themeColorMs);

  var appleapptitle = document.createElement("meta");
  appleapptitle.name = "apple-mobile-web-app-title";
  appleapptitle.content = location.name + " " + "- menuByte.it";
  document.getElementsByTagName("head")[0].appendChild(appleapptitle);

  var safariPinnedTab = document.createElement("link");
  safariPinnedTab.href = "/img/icons/safari-pinned-tab.svg";
  safariPinnedTab.color = location.color.secondary_hex;
  safariPinnedTab.rel = "mask-icon";

  document.getElementsByTagName("head")[0].appendChild(safariPinnedTab);

  WebFontLoader.load({
    google: {
      families: [location.font1.name, location.font2.name],
    },
  });

  if (location.theme_id === 99) {
    store.dispatch("setLocation", location);

    new Vue({
      i18n,
      data: {
        /*location: location*/
      },
      router: routerRoundedTheme,
      store,
      render: (h) => h(RoundedTheme),
    }).$mount("#app");
  } else if (
    location.theme_id == null ||
    location.theme_id === 1 ||
    location.theme_id === 2 ||
    location.theme_id === 3
  ) {
    //Tema Fancy
    if (location.theme_id == null || location.theme_id === 1) {
      location.extra = {
        showimage: true,
        showicon: true,
      };
    }

    //Tema Standard
    if (location.theme_id == 2) {
      location.extra = {
        showimage: false,
        showicon: true,
      };
    }

    //Tema Light
    if (location.theme_id == 3) {
      location.extra = {
        showimage: false,
        showicon: false,
      };
    }

    //let avaibleOrderTypes = '[{"id":3,"location_id":75,"order_type_id":1,"enable":1,"settings":{"selectedSource":"menubyte","selectedOrderToday":"yes","notes": "blablabla","zipCodes":"888,8888,88888","shippingFee":"10","shippingFree":"9.8","email":"test@test.com"},"created_at":"2020-08-22T13:33:37.000000Z","updated_at":"2020-08-22T14:31:51.000000Z","order_type":[{"id":1,"name":"Consegna a domicilio","slug":"domicilio","created_at":null,"updated_at":null}]},{"id":4,"location_id":75,"order_type_id":2,"enable":1,"settings":{"selectedSource":"whatsapp","selectedOrderToday":"yes","notes":"ttttttake","whatsapp":"takeaway"},"created_at":"2020-08-22T13:58:26.000000Z","updated_at":"2020-08-22T13:59:02.000000Z","order_type":[{"id":2,"name":"Asporto","slug":"asporto","created_at":null,"updated_at":null}]},{"id":5,"location_id":75,"order_type_id":3,"enable":1,"settings":{"notes":"tavolo","password":"pswtavolo"},"created_at":"2020-08-22T14:29:33.000000Z","updated_at":"2020-08-22T14:30:29.000000Z","order_type":[{"id":3,"name":"Servizio al tavolo","slug":"tavolo","created_at":null,"updated_at":null}]}]';
    //let opening_hours = '{"monday":[{"open":null,"close":null,"id":"1","isOpen":false}],"tuesday":[{"open":"0800","close":"1200","id":"2","isOpen":true},{"id":"ke74l2li","open":"1500","close":"1800","isOpen":true}],"wednesday":[{"open":null,"close":null,"id":"3","isOpen":false}],"thursday":[{"open":null,"close":null,"id":"4","isOpen":false}],"friday":[{"open":"1000","close":"1200","id":"5","isOpen":true},{"id":"ke74qvk5","open":null,"close":null,"isOpen":true}],"saturday":[{"open":null,"close":null,"id":"6","isOpen":true}],"sunday":[{"open":null,"close":null,"id":"0","isOpen":false}]}';
    //location.avaibleOrderTypes = JSON.parse(avaibleOrderTypes);
    //location.opening_hours = JSON.parse(opening_hours);

    store.dispatch("setLocation", location);

    new Vue({
      i18n,
      data: {
        /*location: location*/
      },
      router: routerDefaultTheme,
      store,
      render: (h) => h(DefaultTheme),
    }).$mount("#app");
  }
}

function notFound() {
  new Vue({
    i18n,
    data: {
      /*location: location*/
    },
    router: routerMenuNotFound,
    store,
    render: (h) => h(MenuNotFound),
  }).$mount("#app");
}

const uuid = window.location.pathname.split("/")[1];

if (uuid != undefined && uuid != "") {
  load(uuid);
} else {
  notFound();
}
